import whyDidYouRender from '@welldone-software/why-did-you-render/dist/no-classes-transpile/umd/whyDidYouRender.min.js';
import { isProduction } from '../service/InfoService';

export default whyDidYouRender;
export const MOCKED_DATA = !isProduction && false;
